import React from 'react';

class ListHeader extends React.Component {
  render() {
    return (
      <div>
        Project Addresses
      </div>
    )
  }
}

export default ListHeader;